import {
  LISTE_SOUS_TYPE_FOURNISSEURS_ACHAT_PAGES,
} from '@/configuration/tiers/tiersConf';

export default function genererCritereRecherche() {
  return {
    auto: null,
    archive: false,
    email: null,
    telephone: null,
    compteComptable: null,
    motifsBlocagesId: [],
    blocageReglement: null,
    villes: [],
    tiers: [],
    sousType: LISTE_SOUS_TYPE_FOURNISSEURS_ACHAT_PAGES.map((el) => el.code),
    competenceFournisseurIds: [],
  };
}
